<template>
  <div class="driverAuth">
    <nav-bar title="司机认证"></nav-bar>
    <div class="bgc"></div>
    <div class="img">
      <div class="item">
        <img
          class="idCard"
          :src="
            formData.drivingLisence
              ? 'https://aihao.oss-cn-beijing.aliyuncs.com' +
                formData.drivingLisence
              : idCard
          "
          alt=""
        />
        <div class="upload" v-if="!formData.drivingLisence">
          <img src="@/assets/icon/bianzu.png" alt="" />
          <span>点击上传</span>
        </div>
        <div v-else class="uploaded">
          <img src="@/assets/icon/success.png" alt="" />
          <span>已上传</span>
        </div>
      </div>
      <div class="item">
        <img
          class="driveCard"
          :src="
            formData.drivingLisenceBack
              ? 'https://aihao.oss-cn-beijing.aliyuncs.com' +
                formData.drivingLisenceBack
              : driveCard
          "
          alt=""
        />
        <div class="upload" v-if="!formData.drivingLisenceBack">
          <img src="@/assets/icon/bianzu.png" alt="" />
          <span>点击上传</span>
        </div>
        <div v-else class="uploaded">
          <img src="@/assets/icon/success.png" alt="" />
          <span>已上传</span>
        </div>
      </div>
    </div>
    <div class="again">
      <p>驾驶证正面</p>
      <p>驾驶证负页</p>
    </div>
    <div class="problem" @click="problem()">
      <img src="@/assets/icon/warning.png" alt="" />
      <span>以下信息为系统自动识别，如不正确请修改《常见问题》</span>
    </div>
    <van-form @submit="onSubmit" error-message-align="right">
      <div class="from">
        <div class="item">
          <span>真实姓名</span>
          <van-field
            v-model="formData.realName"
            input-align="right"
            placeholder="请输入真实姓名"
            :rules="[{ required: true, message: '请输入真实姓名' }]"
          />
        </div>
        <div class="item">
          <span>驾驶证号</span>
          <van-field
            v-model="formData.idCardId"
            input-align="right"
            placeholder="请输入驾驶证号"
            :rules="[{ required: true, message: '请输入驾驶证号' }]"
          />
        </div>
        <div class="item">
          <span>准驾车型</span>
          <van-field
            v-model="formData.carType"
            input-align="right"
            placeholder="请输入准驾车型"
            :rules="[{ required: true, message: '请输入准驾车型' }]"
          />
        </div>
        <div class="item">
          <span>驾驶证初次领证日期</span>
          <van-field
            v-model="formData.drivingStartTime"
            input-align="right"
            placeholder="请输入驾驶证初次领证日期"
            :rules="[{ required: true, message: '请输入驾驶证初次领证日期' }]"
          />
        </div>
        <div class="item">
          <span>驾驶证有效期</span>
          <van-field
            v-model="formData.drivingValidStartTime"
            input-align="right"
            placeholder="请输入驾驶证有效期"
            :rules="[{ required: true, message: '请输入驾驶证有效期' }]"
          />
        </div>
        <div class="item">
          <span>有效期截止日期</span>
          <van-field
            v-model="formData.drivingValidEndTime"
            input-align="right"
            placeholder="请输入有效期截止日期"
            :rules="[{ required: true, message: '请输入有效期截止日期' }]"
          />
        </div>
        <div class="item">
          <span>档案编号</span>
          <van-field
            v-model="formData.fileNumber"
            input-align="right"
            placeholder="请输入档案编号"
            :rules="[{ required: true, message: '请输入档案编号' }]"
          />
        </div>
      </div>
      <div class="btn">
        <van-checkbox v-model="checked" icon-size="14px"
          >App实名认证协议
        </van-checkbox>
        <van-button
          type="primary"
          color="rgba(33,37,41,1)"
          block
          native-type="submit"
          >同意协议
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import { Field, Checkbox, Button, Form, Toast } from "vant";
import API from "@/api/Resource";

export default {
  name: "driverAuth",
  data() {
    return {
      idCard: require("@/assets/icon/Mask.png"),
      driveCard: require("@/assets/icon/Mask(1).png"),
      checked: true,
      formData: {
        accountId: "76A4A08D-7EDE-44CC-A2A1-85180562C59C",
        drivingLisence: "/Company/Logo/6DA6E2710B3F536C7BEA3FEB47A5353D.jpg",
        drivingLisenceBack:
          "/Company/Logo/E1A261ADD9C88FE21E514F7C82233251.jpg",
        realName: "张三",
        idCardId: "130124199202020020",
        carType: "C1",
        drivingStartTime: "20200101",
        drivingValidEndTime: "20200101",
        drivingValidStartTime: "20200101",
        fileNumber: "370211375349"
      }
    };
  },
  components: {
    NavBar,
    "van-field": Field,
    "van-checkbox": Checkbox,
    "van-button": Button,
    "van-form": Form
  },
  created() {
    this.driverCertification();
  },
  methods: {
    async driverCertification() {
      const data = await API.getDriverCertification(
        "76A4A08D-7EDE-44CC-A2A1-85180562C59C"
      );
      console.log(data);
    },
    problem() {
      this.$router.push({ name: "problem" });
    },
    // 提交操作
    async onSubmit() {
      const {
        data: { message },
        status
      } = await API.driverCertification(this.formData);
      if (status == 200) {
        Toast(message);
      }
    }
  }
};
</script>

<style scoped lang="less">
.driverAuth {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: rgba(247, 247, 247, 1);

  .bgc {
    height: 7px;
  }

  .img {
    display: flex;
    justify-content: space-around;
    padding: 6px 15px;
    background-color: #fff;

    .idCard,
    .driveCard {
      width: 165px;
      height: 110px;
    }

    .item {
      position: relative;

      .upload {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #414d5c;
        opacity: 0.6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 30px;
        }

        span {
          display: block;
          color: #ffffff;
          font-size: 14px;
        }
      }

      .uploaded {
        width: 100%;
        height: 30px;
        line-height: 30px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: #414d5c;
        opacity: 0.6;
        text-align: center;

        img {
          width: 14px;
          vertical-align: middle;
        }

        span {
          color: #ffffff;
          display: inline-block;
          margin-left: 6px;
          font-size: 12px;
          vertical-align: middle;
        }
      }
    }
  }

  .again {
    display: flex;
    justify-content: space-around;
    padding: 0 15px;
    background-color: #fff;

    p {
      margin: 0;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
    }
  }

  .problem {
    padding: 0 21px;
    background-color: #fff;

    img {
      width: 14px;
    }

    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(196, 198, 205, 1);
      vertical-align: middle;
      margin-left: 6px;
    }
  }

  .from {
    background-color: #fff;

    .item {
      height: 49px;
      padding: 0 15px;
      display: flex;
      align-items: center;

      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(158, 160, 165, 1);
      }

      .van-field {
        width: 221px;
        position: absolute;
        right: 0;
      }
    }
  }

  .btn {
    width: 375px;
    height: 112px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    bottom: 0;
    padding: 15px 25px;
    box-sizing: border-box;

    .van-checkbox {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(98, 104, 112, 1);
    }

    .van-button {
      margin-top: 18px;
    }
  }
}

/deep/ .van-field__error-message--right {
  display: none;
}
</style>
